// 防抖
export function debounce(fn, delay = 300) {
    let timer = null;
    return function () {
        clearTimeout(timer);
        let that = this;
        let arg = arguments;
        timer = setTimeout(() => {
            fn.apply(that, arg)
        }, delay)
    }
}